import { render, staticRenderFns } from "./comanswerlist.vue?vue&type=template&id=0674fc4f&scoped=true"
import script from "./comanswerlist.vue?vue&type=script&lang=js"
export * from "./comanswerlist.vue?vue&type=script&lang=js"
import style0 from "./comanswerlist.vue?vue&type=style&index=0&id=0674fc4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0674fc4f",
  null
  
)

export default component.exports